module.exports = __webpack_public_path__ + "static/media/contato.b38741eb.svg";